import {Button} from "./button"
export function Toast({ children, status }) {
  const toastStyle = {
    position: "fixed",
    bottom: "10px",
    left: "0",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    transform: status ? "translateY(0)" : "translateY(100%)",
    opacity: status ? "1" : "0",
    transition: "transform 0.5s ease-in-out, opacity 0.5s ease-in-out",
    zIndex:"999999999999999999999999999"
  };

  return (
    <div style={toastStyle}>
      <div style={{ width: "fit-content", margin: "auto", display: "flex" }}>
        <div style={{display:"block",textAlign:"center"}}>
            {/* <div style={{height:"10px"}}></div> */}
            <Button>
            <span style={{padding:"0 10px"}}>
              <i>{children} ...</i>
            </span>
            </Button>
          </div>
        </div>
      </div>
  );
}
